import React  from 'react'
import { Card, CardBody, Button, Input, Col, Container, Row, ListGroup, ListGroupItem } from "reactstrap";
import { useDispatch } from 'react-redux';
import { Delete_fav_Prompt_Category } from '../../slices/thunks';
import { waitForDecision } from '../../utility/wait_for_confirmation';
import { close_confirm_modal, open_confirm_modal } from '../../slices/Confirm_Modal/reducer';

function Group_Favourite_Prompt_Category({ category , group_id }) {
    const dispatch = useDispatch()
  
    const delete_fav_prompt_cat = (Prompt_Category) => {
        dispatch(open_confirm_modal(`Are you sure you want to delete ${Prompt_Category} category?`))
      
        
        waitForDecision().then((decision)=>{
            if(decision){
                dispatch(Delete_fav_Prompt_Category({ Prompt_Category , group_id }))
            }
            dispatch(close_confirm_modal())
        })
         
    }



  return (

        <ListGroupItem> <span>{category}</span> <i onClick={()=>{
            delete_fav_prompt_cat(category)
        
        }} className="ri-delete-bin-line align-middle me-2"></i></ListGroupItem>
            

        

  )
}


export default Group_Favourite_Prompt_Category